import { Shared_DateFormats } from "src/backend/openapi/v1";
import { useCallback } from "react";
import { useDateFormatsT } from "src/translation-hooks/date-formats";

export const useDateFormatsTranslation = () => {
  const t = useDateFormatsT();

  const getDateFormatTranslation = useCallback(
    (value: string | Shared_DateFormats) => {
      const enumValue: Shared_DateFormats = typeof value === "string" ? parseInt(value) : value;
      switch (enumValue) {
        case Shared_DateFormats.DDMMYYYY:
          return t.DDMMYYYY;
        case Shared_DateFormats.MMDDYYYY:
          return t.MMDDYYYY;
        case Shared_DateFormats.YYYYDDMM:
          return t.YYYYDDMM;
        case Shared_DateFormats.YYYYMMDD:
          return t.YYYYMMDD;

        default:
          return "";
      }
    },
    [t]
  );

  return { getDateFormatTranslation };
};
